<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">แก้ไขข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="grid_header">
          <div></div>
          <div class="text-center ma-4">
            <div class="text_font">ฟอร์มส่งคืน/เปลี่ยนสินค้า</div>
            <div>บริษัท ฟาร์มาแคร์ พลัส จำกัด</div>
          </div>
          <div class="ma-4">
            <div class="grid_flex justify-end">
              <div class="mr-2">เลขที่เอกสาร :</div>
              <div>{{ data_set.doc_no }}</div>
            </div>
            <!-- <div class="grid_flex justify-end">
              <div class="mr-2">TF :</div>
              <div>{{ data_set.tf_no }}</div>
            </div> -->
          </div>
        </div>
        <div class="pa-6">
          <div class="grid_list">
            <div>{{ data_set.supplier_name }}</div>
            <div class="grid_flex">
              <div class="mr-5">ผู้แทน</div>
              <div>{{ data_set.representative }}</div>
            </div>
          </div>
          <div class="grid_list mt-2">
            <div class="grid_flex">
              <div class="mr-5">วันที่แจ้งคืนสินค้า</div>
              <div>{{ diffDateTH(return_date) }}</div>
            </div>
            <div class="grid_flex">
              <div class="mr-5">วันที่ส่งสินค้า</div>
              <div>{{ diffDateTH(send_date) }}</div>
            </div>
            <div class="grid_flex">
              <div class="mr-5">ผู้แจ้งคืน</div>
              <div>{{ user_list.name }}</div>
            </div>
            <div class="grid_flex">
              <div class="mr-5">แจ้งโดย</div>
              <div v-if="data_set.notified_by === 0">Line.</div>
              <div v-else-if="data_set.notified_by === 1">โทร</div>
              <div v-else-if="data_set.notified_by === 2">ต่อหน้า</div>
            </div>
          </div>
          <div class="grid_list mt-2">
            <div class="grid_flex">
              <div class="mr-2">สาเหตุที่ส่งคืน</div>
              <div v-if="data_set.cause_return === 0">ของมาผิด</div>
              <div v-else-if="data_set.cause_return === 1">ของไม่ได้สั่ง</div>
              <div v-else-if="data_set.cause_return === 2">ชำรุด</div>
              <div v-else-if="data_set.cause_return === 3">{{ data_set.cause_text }}</div>
            </div>
            <div class="grid_flex">
              <div class="mr-5 red--text">วิธีการแก้ไข้</div>
              <div v-if="data_set.issue_select === 0">ทำใบ C/N</div>
              <div v-else-if="data_set.issue_select === 1">คืนเป็นสินค้าเดิม</div>
              <div v-else-if="data_set.issue_select === 2">{{ data_set.note_issue }}</div>
              <div v-else-if="data_set.issue_select === 3">คืนไปเลยเพราะส่งผิด</div>
            </div>
          </div>
        </div>
        <div class="pa-2">
          <v-divider/>
          <v-data-table :headers="headers" :items="datalist" key="index" :items-per-page="perPage" mobile-breakpoint="0" hide-default-footer>
            <template v-slot:item="dataDetails">
              <tr>
                <td>{{ dataDetails.index + 1 }}</td>
                <td>{{ dataDetails.item.product_name }}</td>
                <td>{{ dataDetails.item.lot_no }}</td>
                <td>{{ dataDetails.item.qty }}</td>
                <td>{{ dataDetails.item.unit_name }}</td>
                <td>
                  <div class="ma-4" v-if="dataDetails.item.reason !== null">{{ dataDetails.item.reason }}</div>
                  <div class="ma-4" v-else>-</div>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-divider/>
        </div>
        <div class="pa-6">
          <document_user :user="user_list.name" :create_time="data_set.create_at" :status="data_set.status" :update_user="data_set.user_name_success" time_update=""/>
        </div>
        <div v-if="data_set.status === 2">
          <div class="pl-6" style="color: #114fd7">การตอบรับจากซัพพลายเออร์</div>
          <div class="pl-md-6 pl-lg-6 pl-xl-6 pb-6">
            <v-form ref="document" @submit.prevent="edit_document">
              <div class="grid_half">
                <div class="grid_half">
                  <div class="ma-3">
                    <div class="mr-2 mb-2">เลขที่เอกสาร</div>
                    <div>
                      <v-text-field color="#86bc3a" label="เลขที่เอกสาร" :rules="[v => !!v || 'กรุณากรอกเลขที่เอกสาร']" v-model="data_set.doc_from_supplier" hide-details="auto" outlined></v-text-field>
                    </div>
                  </div>
                  <div class="ma-3">
                    <div class="mr-2 mb-2">วันที่ใบส่งสินค้า</div>
                    <div class="">
                      <v-menu ref="menu_refund_date" v-model="menu_refund_date" :close-on-content-click="false" :return-value.sync="receipt_date" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field color="#86bc3a" v-model="receipt_date" label="วันที่ใบส่งสินค้า(วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณากรอกวันที่ใบส่งสินค้า']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                        </template>
                        <v-date-picker locale="TH" color="#86bc3a" @change="diffDate_TH(date_en)" :min="start_date" v-model="date_en" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="selectRefundDate()">
                            ตกลง
                          </v-btn>
                          <v-btn text color="primary" @click="menu_refund_date = false">
                            ยกเลิก
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid_half mt-n6">
                <div class="ma-3">
                  <div class="mr-2">หมายเหตุ</div>
                  <v-textarea color="#86bc3a" label="หมายเหตุ" style="font-size: 18px !important" v-model="data_set.note" hide-details="auto" outlined></v-textarea>
                </div>
              </div>
              <div class="text-left grid_btn">
                <v-btn v-if="data_set.status === 2" x-large class="grad-warning-bg white--text mr-4 ml-4" style="font-size: 18px" type="submit">แก้ไขเอกสาร</v-btn>
              </div>
            </v-form>
          </div>
        </div>
        <div class="pt-3 pb-5 text-center grid_btn">
          <v-btn v-if="data_set.status === 1" x-large class="grad-cancel-bg white--text mr-4 ml-4" style="font-size: 18px" @click="modal_return_product = true">ได้รับ ใบลดหนี้/คืนสินค้า</v-btn>
          <v-btn v-if="data_set.status === 2" x-large class="grad-danger-bg white--text mr-4 ml-4" style="font-size: 18px" @click="getApprove(data_set.doc_no)">รออนุมัติ</v-btn>
          <v-btn x-large class="grad-grey-bg white--text mr-4 ml-4" @click="print_document(data_set.doc_no)" style="font-size: 18px">พิมพ์เอกสาร</v-btn>
        </div>
        <v-dialog v-model="modal_return_product" max-width="700">
          <v-card>
            <v-card-title>
              ข้อมูลใบลดหนี้ / คืนสินค้า / เปลี่ยนสินค้า / อื่นๆ
            </v-card-title>
            <v-divider/>
            <div class="pa-5">
              <v-form ref="save_receipt" @submit.prevent="save_receipt">
                <div class="grid_full">
                  <div class="mr-1">
                    <v-text-field color="#86bc3a" label="เลขที่เอกสารตอบกลับจากซัพพลายเออร์" v-model="send_data_modal.return_no" prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกเลขที่เอกสาร']" hide-details="auto" required outlined></v-text-field>
                  </div>
                </div>
                <div class="grid_full mt-5">
                  <div class="mr-1">
                    <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="send_data_modal.dateTH" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field color="#86bc3a" v-model="send_data_modal.dateTH" label="วันที่ใบส่งสินค้า (วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณากรอกวันที่ใบส่งสินค้า']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                      </template>
                      <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH_picker(send_data_modal.dateEN)" v-model="send_data_modal.dateEN" :min="start_date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="selectDate()">
                          ตกลง
                        </v-btn>
                        <v-btn text color="primary" @click="menu_date = false">
                          ยกเลิก
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </div>
                </div>
                <div class="grid_full mt-n1">
                  <div class="mr-1">
                    <v-text-field color="#86bc3a" label="หมายเหตุ" v-model="send_data_modal.return_note" prepend-inner-icon="mdi-message-bulleted" :rules="[v => !!v || 'กรุณากรอกหมายเหตุ']" hide-details="auto" required outlined></v-text-field>
                  </div>
                </div>
                <div class="pa-1 text-center mt-5">
                  <v-btn x-large type="submit" class="grad-success-bg white--text" style="font-size: 18px">บันทึกข้อมูล</v-btn>
                </div>
              </v-form>
            </div>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>

<script>
import document_user from "@/components/admin/document_stock/header_document/document_user";
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Document_details_complete",
  components: {
    document_user
  },
  data() {
    return {
      loading_page: false,
      modal_return_product: false,
      date: '',
      send_date: '',
      perPage: -1,
      return_date: '',
      date_en: '',
      menu_date: false,
      menu_refund_date: false,
      start_date: null,
      receipt_date: null,
      alert_success: false,
      headers: [
        {
          text: 'ลำดับ',
          value: 'id',
          fixed: true,
          width: '120px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'รหัสล็อต',
          value: 'lot_no',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวน',
          value: 'qty',
          fixed: true,
          width: '120px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          sortable: false,
          fixed: true,
          width: '120px',
        },
        {
          text: 'หมายเหตุ',
          value: 'reason',
          fixed: true,
          width: '250px',
        },
      ],
      datalist: [],
      user_list: [],
      data_set: [],
      send_data_modal: {
        dateTH: '',
        dateEN: '',
        return_doc_id: '',
        return_no: '',
        return_note: '',
      },
    }
  },
  methods: {
    async selectDate() {
      this.$refs.menu_date.save(this.send_data_modal.dateTH)
      this.menu_date = false
    },
    async selectRefundDate() {
      this.$refs.menu_refund_date.save(this.receipt_date)
      this.menu_refund_date = false
    },
    diffDateTH_picker(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const date_th = day+'-'+month+'-'+year
      return this.send_data_modal.dateTH = date_th
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      return day+'/'+month+'/'+year
    },
    diffDate_TH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'-'+month+'-'+year
      return this.receipt_date = final_date
    },
    diffDateEN() {
      const diff = this.receipt_date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year+'-'+month+'-'+day
    },
    get_all() {
      this.loading_page = true
      HTTP.post('/returnproductdocs/detail', {
        return_doc_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.data_set = res.data.doc
          this.send_date = res.data.doc.send_date
          this.return_date = res.data.doc.return_date
          if (res.data.doc.receipt_date !== null && res.data.doc.receipt_date !== undefined) {
            this.receipt_date = res.data.doc.receipt_date
            this.diffDate_TH(this.receipt_date)
          }
          else {
            this.receipt_date = ''
          }
          this.datalist = res.data.doc_lists
          this.user_list = res.data.users.find((data) => {
            return data.id === this.data_set.return_user_id
          })
          this.send_data_modal.return_doc_id = res.data.doc.return_doc_id
          this.loading_page = false
        }
      })
    },
    save_receipt() {
      if (this.$refs.save_receipt.validate()) {
        this.alert_success = true
        HTTP.post('/returnproductdocs/changesuccess' ,{
          return_doc_id: this.$route.params.id,
          status: 2,
          return_no: this.send_data_modal.return_no,
          date_reduce: this.send_data_modal.dateEN,
          return_note: this.send_data_modal.return_note,
          user_login_id: this.$store.state.userDetail.id,
        }).then((res) => {
          if (res.data.success === true) {
            this.return_product = false
            this.alert_success = false
            this.modal_return_product = false
            this.get_all()
          }
        })
      }
    },
    getApprove(id) {
      Swal.fire({
        text: 'คุณต้องการอนุมัติการส่งคืนสินค้าหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.alert_success = true
          HTTP.post('/returnproductdocs/changesuccess' ,{
            return_doc_id: id,
            status: 3,
            user_login_id: this.$store.state.userDetail.id,
            user_name: this.$store.state.userDetail.name,
          }).then((res) => {
            if (res.data.success === true) {
              this.alert_success = false
              this.get_all()
            }
          })
        }
      })
    },
    edit_document() {
      if (this.$refs.document.validate()) {
        Swal.fire({
          text: 'คุณต้องการแก้ไขข้อมูลหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            this.alert_success = true
            HTTP.post('/returnproductdocs/editcnfromsupplier', {
              return_doc_id: this.data_set.return_doc_id,
              doc_from_supplier: this.data_set.doc_from_supplier,
              receipt_date: this.diffDateEN(),
              note: this.data_set.note
            }).then((res) => {
              if (res.data.success === true) {
                this.alert_success = false
                this.get_all()
              }
            })
          }
        })
      }
    },
    print_document(doc_no) {
      window.open('https://www.pharmacare-plus.com/returnpdf/'+ doc_no, '_blank')
    }
  },
  mounted() {
    this.get_all()
  }
}
</script>

<style scoped>
.text_font {
  font-size: 26px;
}
.grid_flex {
  display: flex;
}
.grid_header {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
}
.grid_list {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
@media only screen and (max-width: 1024px) {
  .grid_list {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
}
@media only screen and (max-width: 700px) {
  .grid_header {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .grid_btn {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
